<!-- Spinner while statuses are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading downloads. Click below try again.
    <button hc-button size="lg" (click)="reloadDownloads()">Reload Downloads</button>
</div>

<div *ngIf="!loadError && !loading" class="pd-content-container">
    <div class="pd-downloads-container">
        <hc-tile class="pd-downloads-tile">
            <div class="pd-downloads-tile-top">
                <div class="tech-library-img"></div>
            </div>
            <div class="pd-downloads-tile-bottom">
                <div class="pd-downloads-header">
                    Technology & Services Catalog
                </div>
                <div class="pd-downloads-description">
                    Provides an overview of Health Catalyst products and professional services. Updated quarterly. Included in contracts.
                    <div class="current-version">Current Version: {{techLibraryName}} <button hc-button buttonStyle="link-inline" routerLink="/downloads-detail" [queryParams]="{type: 'techlibrary'}">
                        Download a previous version</button></div>
                    <a hc-button buttonStyle="primary-alt" class="download-button" target="_blank" href="/tech-catalog">Download Current Catalog</a>
                </div>
            </div>
        </hc-tile>
        <hc-tile class="pd-downloads-tile">
            <div class="pd-downloads-tile-top">
                <div class="definitions-img"></div>
            </div>
            <div class="pd-downloads-tile-bottom">
                <div class="pd-downloads-header">
                    Catalog Spreadsheet
                </div>
                <div class="pd-downloads-description">
                    Lists all technology and services in CSV file. Includes ID, Name, Category, Type, Product Line, Status, SLA, Technical Description, and Revision Date.
                    <div class="current-version">Current Version: {{metadataName}} <button hc-button buttonStyle="link-inline" routerLink="/downloads-detail" [queryParams]="{type: 'metadata'}">
                        Download a previous version</button></div>
                    <button hc-button buttonStyle="primary-alt" class="download-button" (click)="downloadFile('metadata')">Download Current Spreadsheet</button>
                </div>
            </div>
        </hc-tile>
    </div>
</div>